import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class EcoFeeCardStyle {
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			${Text.CSS}

			h4 {
				margin: 0;
			}

			.headline:not(:first-child) {
				margin-top: ${spacing.space100 / 16}rem;
			}

			.headline {
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			.container {
				display: flex;
				flex-direction: column;
				color: ${color.text.dark};
			}

			.link {
				margin-top: ${spacing.space50 / 16}rem;
			}

			.details > *:not(:first-child) {
				margin-top: ${spacing.space100 / 16}rem;
			}

			.details {
				margin-top: ${spacing.space250 / 16}rem;
			}

			.row {
				display: flex;
				justify-content: space-between;
			}

			.line {
				height: ${1 / 16}rem;
				background-color: ${color.border.light};
			}

			.no-margin {
				margin: 0;
			}
		`;
    }
}
//# sourceMappingURL=EcoFeeCardStyle.js.map